import { Icon } from "@utp/react-components-prod";
import useRoleActive from "hooks/useRoleActive";

interface ILogoutMenuProps {
  isActiveLogout: boolean;
  tabIndexValue: number;
  setIsActiveLogout: React.Dispatch<React.SetStateAction<boolean>>;
  onLogout: () => void;
}
const LogoutMenu = ({
  tabIndexValue,
  isActiveLogout,
  setIsActiveLogout,
  onLogout,
}: ILogoutMenuProps) => {

  const {isRoleEPG} = useRoleActive();

  const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === "Escape") {
      setIsActiveLogout(false);
    }
    if (event.key === "Tab" && isActiveLogout) {
      setIsActiveLogout(false);
    }
  };

  const handleGetClassHover = () => {
    return isRoleEPG ? "hover:bg-primary-30 focus:bg-primary-30 " : "hover:bg-red-30 focus:bg-red-30";
  }

  return (
    <div className="flex items-center">
      <button
        className={`${handleGetClassHover()} w-10 h-10 rounded-md transition duration-300 ease-in-out cursor-pointer mx-4 `}
        onClick={() => setIsActiveLogout(!isActiveLogout)}
        aria-label="Abrir menú de cierre de sesión"
        aria-haspopup="true"
        aria-expanded={isActiveLogout}
        tabIndex={tabIndexValue}
        data-testid="btn-logout-open"
      >
        <Icon
          iconName={"chevron-down"}
          className={`text-color-primary transform transition duration-300 ease-in-out ${
            isActiveLogout ? "rotate-180" : ""
          }`}
          size={24}
        />
      </button>
      <button
        className={`h-56 w-200 absolute top-24 right-0 shadow-md rounded-md flex items-center px-8 text-color-02 cursor-pointer transition-all duration-300 ease-in-out bg-white ${
          isActiveLogout
            ? "opacity-100 translate-y-0"
            : "opacity-0 -translate-y-4 pointer-events-none"
        } hover:bg-gray-50 focus:bg-gray-50`}
        onClick={onLogout}
        onKeyDown={handleKeyDown}
        aria-hidden={!isActiveLogout}
        tabIndex={isActiveLogout ? 0 : -1}
        data-testid="btn-logout"
      >
        <Icon iconName="log-out" className="mr-2 text-neutral-02" size={14} />
        <p>Cerrar sesión</p>
      </button>
    </div>
  );
};

export default LogoutMenu;
